import React from 'react'
import { Form, Button } from 'react-bootstrap'

export const GroupedShippingPricesView = (props) => {
    return <div>
        <select className="form-select" value={props.countries} onChange={(e) => props.onSelectCountry(e)}>
            <option value='EU'>EU</option>
            <option value='ROW'>ROW</option>
        </select>
        <select className="form-select" value={props.serviceType} onChange={(e) => props.onSelectServiceType(e)} >
            <option value='untracked'>untracked</option>
            <option value='tracked'>Tracked</option>
        </select>
        <Form onSubmit={props.onSubmit}>
            <Form.Group>
                {props.countryCodes.map((countryCode) => {
                    return <Form.Row className="d-flex align-items-end"><Form.Label>{countryCode} </Form.Label>
                        <Form.Control style={{ width: "15rem" }} type="number" step=".01" defaultValue={0} placeholder="Enter £revenue" name={countryCode} />
                    </Form.Row>
                })}
                <Form.Label>Average Weight (grams)</Form.Label>
                <Form.Control type="Number" placeholder="670" name="avgWeight" style={{ width: "20rem" }} />

            </Form.Group>
            <div>
                <div>Enter PIN to access:</div>
                <div><input value={props.password} onChange={(e) => { props.setPassword(e.target.value) }} ></input></div>
            </div>
            <Button disabled={props.password === '4207' ? false : true} type="submit">Submit</Button>
        </Form>
        {props.weightedCost && <div>updated</div>}


    </div>
}